import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionCardForm, AddAnotherCardForm, GiftNotesBlockForm } from '../../model';

@Component({
  selector: 'multi-shipment-gift-notes-block',
  templateUrl: './gift-notes-block.component.html',
  styleUrls: ['./gift-notes-block.component.scss'],
  standalone: false,
})
export class GiftNotesBlockComponent {
  @Input({ required: true }) formGroup!: FormGroup<GiftNotesBlockForm>;

  get addGiftNoteCard(): FormGroup<ActionCardForm> {
    return this.formGroup.controls.addGiftNoteCard;
  }

  get addAnotherGiftNoteCard(): FormGroup<AddAnotherCardForm> {
    return this.formGroup.controls.addAnotherGiftNoteCard;
  }

  onRichTextChange(control: FormControl<string>, content: string): void {
    control.setValue(content);
    control.markAsDirty();
  }
}
